<template>
  <el-card class="box-card">
    <div slot="header" class="clearfix">
      <!-- 标题 -->
      <span class="font-sz24">操作列表</span>
      <div class="head-text">
        <el-input
          placeholder="用户姓名"
          class="search-input"
          v-model="name"
        ></el-input>
        <el-date-picker
          class="search-input2"
          value-format="yyyy/MM/dd"
          v-model="timeArr"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          @change="changetime"
        >
        </el-date-picker>
        <el-input
          placeholder="操作内容"
          class="search-input"
          v-model="text"
        ></el-input>
        <el-button
          @click="GetoperationRecordList"
          type="primary"
          class="mar-r20"
          >查询</el-button
        >
        <el-button @click="DeloperationRecord" type="danger" class="mar-r20"
          >删除记录</el-button
        >
      </div>
    </div>
    <!-- 表格 -->
    <el-table
      @selection-change="handleSelectionChange"
      v-loading="loading"
      :data="list"
      class="width100"
      max
      height="72vh"
    >
      <el-table-column
        align="center"
        type="selection"
        width="55"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="user04"
        label="用户姓名"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="user02"
        label="账户"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="oprc04"
        label="操作模块"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="oprc05"
        label="IP"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="oprc07"
        label="操作时间"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="oprc06"
        label="操作内容"
      ></el-table-column>
    </el-table>
    <div class="page">
      <el-pagination
        align="center"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageIndex"
        :page-sizes="[10, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
  </el-card>
</template>

<script>
import { GetoperationRecordList, DeloperationRecord } from "@/setAxios";
export default {
  data() {
    return {
      timeArr: [],
      name: "",
      time: "",
      text: "",
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      loading: false,
      list: null,
      multipleSelection: []
    };
  },
  created() {
    this.GetoperationRecordList();
  },
  methods: {
    async DeloperationRecord() {
      this.$confirm("是否删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let oprcidArr = [];
        this.multipleSelection.forEach(ele => {
          oprcidArr.push(ele.oprc01);
        });
        //console.log(oprcidArr);
        let oprcid = oprcidArr.join(",");
        let params = {
          oprcid
        };
        DeloperationRecord(params).then(res => {
          if (res.Code > 0) {
            this.$message({
              type: "success",
              message: "删除成功"
            });
            this.GetoperationRecordList();
          }
        });
      });
    },
    changetime(val) {
      if (val) {
        this.time = this.timeArr.join("-");
      } else {
        this.time = "";
      }
    },
    async GetoperationRecordList() {
      let params = {
        cid: localStorage.getItem("pid"),
        name: this.name,
        time: this.time,
        text: this.text,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      };
      let res = await GetoperationRecordList({ params });
      this.list = res.Data.list;
      this.total = res.Data.total;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.GetoperationRecordList();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.GetoperationRecordList();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    }
  }
};
</script>

<style lang="less" scoped>
.page {
  height: 80px;
  margin-top: 10px;
}
.changUpload {
  height: 50vh;
  text-align: center;
  .ZIP {
    width: 35%;
    height: 75%;
    margin-left: 10%;
    float: left;
    border: 2px solid #eee;
    padding: 20px;
    box-sizing: border-box;
    cursor: pointer;
    p {
      font-size: 14px;
      margin-top: 30px;
      height: 50px;
    }
    img {
      width: 100px;
      margin-top: 50px;
    }
  }
  .ZIP:hover {
    background: #eee;
    border-color: skyblue;
  }
  .REVIT:hover {
    background: #eee;
    border-color: skyblue;
  }
  .REVIT {
    width: 35%;
    height: 75%;
    float: left;
    margin-left: 5%;
    border: 2px solid #eee;
    padding: 20px;
    box-sizing: border-box;
    cursor: pointer;
    p {
      font-size: 14px;
      margin-top: 30px;
      height: 50px;
    }
    img {
      width: 100px;
      margin-top: 50px;
    }
  }
}
// 新增
.font-sz24 {
  font-size: 24px;
}
.head-text {
  float: right;
  margin-top: -4px;
}
.search-input {
  width: 200px;
  margin-right: 20px;
}
.search-input2 {
  width: 300px;
  margin-right: 20px;
}
.mar-r20 {
  margin-right: 20px;
}
.width100 {
  width: 100%;
}
</style>
